import { IEmailTemplate } from "../interfaces/order";
import { MACHINE_VALID_STATUS, ORDER_STATUS } from "./constants";

// Solo campos de presentación: ORDER_STATUS no debe pisar datos persistidos (ej. description).
const mergeWithOrderStatus = (emailTemplate: IEmailTemplate): IEmailTemplate => {
  const orderStatus = ORDER_STATUS.find(({ id }) => emailTemplate.status === id);
  if (!orderStatus) return emailTemplate;
  const { id, label, type } = orderStatus;
  return { ...emailTemplate, id, label, type };
};

export const filterMachineValidTemplates = (emailTemplates: IEmailTemplate[]): IEmailTemplate[] =>
  emailTemplates
    .filter(({ status }) => MACHINE_VALID_STATUS.includes(status))
    .map(mergeWithOrderStatus);
